import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { BaseHeader } from './BaseHeader';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsPageHeader() {
  var _collectionResult$dat;
  const collectionResult = useCollectionQuery();
  const collectionName = (_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.publishedListing.name;
  return /*#__PURE__*/_jsx(BaseHeader, {
    dataTestId: "search-page-header",
    backBreadcrumb: !collectionName,
    title: collectionName || /*#__PURE__*/_jsx(Text, {
      typography: "heading-600",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.searchResults"
      })
    }),
    pathKey: collectionName ? 'FEATURED_COLLECTION' : 'SEARCH_RESULTS'
  });
}